// ------------------------------------------------------
// Availability States
// ------------------------------------------------------
// 1 → Sold Out (deny backorders)
// 2 → Preorder (continue + preorder = true + dispatch date present)
// 3 → Backorder (continue + preorder = false)
// 4 → Fallback Preorder / Sold Out (no metafield but tagged or general sold out)
// 5 → In Stock
// ------------------------------------------------------

function getVariantAvailabilityState(variant) {
  if (!variant) return null;

  const metafieldData = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const preorderFlag = window.variantMetafields?.[variant.id]?.preorder ?? "false";

  // Case 1: Sold out (deny backorders)
  if (variant.inventory_quantity <= 0 && variant.inventory_policy === 'deny') {
    return 1;
  }

  // Case 2: Preorder
  if (
    variant.inventory_quantity <= 0 &&
    variant.inventory_policy === 'continue' &&
    preorderFlag === "true" &&
    metafieldData
  ) {
    return 2;
  }

  // Case 3: Backorder allowed (preorder = false)
  if (
    variant.inventory_quantity <= 0 &&
    variant.inventory_policy === 'continue'
  ) {
    return 3;
  }

  // Case 4: Fallback Preorder / Sold Out
  if (variant.inventory_quantity <= 0) {
    return 4;
  }

  // Case 5: In Stock
  return 5;
}

// ------------------------------------------------------
// Main UI Update Function
// ------------------------------------------------------
function updateProductUI(variant) {
  const container = document.querySelector('.leave_warehouse');
  const addButton = document.querySelector('button.addToCartBtn');
  const notifyBtn = document.querySelector('.notifyjs');
  if (!container || !variant || !addButton) return;

  const instockEl = container.querySelector('.instock');
  const oosEl = container.querySelector('.outofstock');
  const newPtag = container.querySelector('.newptag');

  const metafieldData = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const preorderFlag = window.variantMetafields?.[variant.id]?.preorder ?? "false";
  const state = getVariantAvailabilityState(variant);

  // --- Utility helpers ---
  const show = (el, show = true) => (el.style.display = show ? 'block' : 'none');
  const setHTML = (el, html = "") => (el.innerHTML = html);
  const setButton = (text, { disabled = false, preorder = false } = {}) => {
    addButton.disabled = disabled;
    addButton.classList.toggle('disabled', disabled);
    addButton.classList.toggle('preorder', preorder);
    addButton.querySelector('span').textContent = text;
  };
  const setNotify = visible => { if (notifyBtn) show(notifyBtn, visible); };

  // --- Reset defaults ---
  setHTML(instockEl, "In Stock");
  setHTML(oosEl, "Out Of Stock");
  setHTML(newPtag, "");
  show(instockEl, false);
  show(oosEl, false);
  setNotify(false);

  // --- Main logic ---
  switch (state) {
    // --------------------------------------------------
    // Case 1: Sold Out (deny backorders)
    // --------------------------------------------------
    case 1:
      show(oosEl, true);
      setHTML(newPtag, ""); // 🔥 No dispatch message
      setButton("WOW! THIS SOLD OUT QUICKLY", { disabled: true });
      setNotify(true);
      break;

    // --------------------------------------------------
    // Case 2: Preorder (continue + preorder = true)
    // --------------------------------------------------
    case 2:
      show(oosEl, true);
      setHTML(newPtag, `Estimated Dispatch: ${metafieldData}`);
      setButton("Pre Order", { preorder: true });
      break;

    // --------------------------------------------------
    // Case 3: Backorder allowed (continue + preorder = false)
    // --------------------------------------------------
    case 3:
      show(instockEl, true);
      setHTML(
        newPtag,
        "Estimated delivery: <span class='days dispatchmessage'><strong>with you in 48 hours</strong></span>"
      );
      setButton("Add To Cart");
      break;

    // --------------------------------------------------
    // Case 4: Fallback Preorder / Sold Out
    // --------------------------------------------------
    case 4:
      if (variant.tags?.includes("preorder") && metafieldData) {
        show(oosEl, true);
        setHTML(newPtag, `Estimated Dispatch: ${metafieldData}`);
        setButton("Pre Order", { preorder: true });
      } else {
        show(oosEl, true);
        setHTML(newPtag, "");
        setButton("Sold Out", { disabled: true });
        setNotify(true);
      }
      break;

    // --------------------------------------------------
    // Case 5: In Stock
    // --------------------------------------------------
    case 5:
      show(instockEl, true);
      let deliveryMsg =
        "Estimated delivery: <span class='days dispatchmessage'><strong>with you in 48 hours</strong></span>";
      if (variant.tags?.includes("stock-is-limited")) {
        deliveryMsg = "BE QUICK! Stock is limited.";
      } else if (variant.tags?.includes("3-business-days")) {
        deliveryMsg =
          "Estimated delivery: <span class='days dispatchmessage'>3 business days</span>";
      } else if (window.productDispatchDefault) {
        deliveryMsg = `Estimated delivery: <span class='days dispatchmessage'>${window.productDispatchDefault}</span>`;
      }
      setHTML(newPtag, deliveryMsg);
      setButton("Add To Cart");
      break;
  }
}
document.addEventListener('DOMContentLoaded', () => {
  // Initial variant
  const initialVariant = window.productJson?.selected_or_first_available_variant;
  if (initialVariant) updateProductUI(initialVariant);

  // Watch for variant changes
  const variantSelectors = document.querySelectorAll('select[name="id"], input[name="id"]');
  variantSelectors.forEach(el => {
    el.addEventListener('change', e => {
      const variantId = parseInt(e.target.value, 10);
      const variant = window.productJson?.variants.find(v => v.id === variantId);
      if (variant) updateProductUI(variant);
    });
  });
});
